import {
  FeedbackMessageFragment,
  GetFeedbackById,
  GetFeedbackByIdVariables,
} from "__generated__/types";
import { Button } from "common/buttons";
import { NoDataError } from "common/components/NoDataError";
import { Section } from "common/components/Section";
import { useSimpleQuery } from "common/graphql/useSimpleQuery";
import gql from "graphql-tag";
import * as React from "react";
import { useState } from "react";
import { FeedbackAnswerForm } from "./FeedbackAnswerForm";
import { FeedbackMessage, feedbackMessageFragment } from "./FeedbackMessage";

interface Props {
  feedbackId: string;
  canAnswer: boolean;
  isQuestion: boolean;
  answerButtonTitle: string;
}

const DATA_QUERY = gql`
  query GetFeedbackById($feedbackId: ID!) {
    feedbackById(id: $feedbackId) {
      id
      messages {
        ...FeedbackMessageFragment
      }
    }
  }
  ${feedbackMessageFragment}
`;

export const FeedbackItem: React.FC<React.PropsWithChildren<Props>> = ({
  feedbackId,
  canAnswer,
  answerButtonTitle,
}) => {
  const { loadingOrError, data, refetch } = useSimpleQuery<
    GetFeedbackById,
    GetFeedbackByIdVariables
  >(DATA_QUERY, {
    variables: {
      feedbackId,
    },
  });

  const [isAnswering, setIsAnswering] = useState(false);
  const answers: FeedbackMessageFragment[] = [];
  if (data?.feedbackById) {
    if (data.feedbackById.messages.length > 0) {
      for (let i = 1; i < data.feedbackById.messages.length; i++) {
        answers.push(data.feedbackById.messages[i]);
      }
    }
  }

  return (
    <div>
      {loadingOrError ? (
        loadingOrError
      ) : !data || !data.feedbackById ? (
        <NoDataError />
      ) : (
        <>
          <FeedbackMessage
            message={data.feedbackById.messages[0]}
            feedbackId={feedbackId}
          />
          {answers.map((e) => (
            <FeedbackMessage key={e.id} message={e} feedbackId={feedbackId} />
          ))}
          <div style={{ marginTop: "2rem" }}>
            {!isAnswering && canAnswer && (
              <Button
                onClick={() => {
                  setIsAnswering(true);
                }}
              >
                {answerButtonTitle}
              </Button>
            )}
            {isAnswering && canAnswer && (
              <Section>
                <FeedbackAnswerForm
                  id={data.feedbackById.id}
                  cancel={() => {
                    setIsAnswering(false);
                  }}
                  complete={() => {
                    setIsAnswering(false);
                    void refetch();
                  }}
                />
              </Section>
            )}
          </div>
        </>
      )}
    </div>
  );
};
